export default function BeaconService(beaconUrl) {
  const img = document.createElement('img')
  img.src = beaconUrl
  img.width = 1
  img.height = 1
  img.className = 'sr-hidden hidden'
  document.body.appendChild(img)
}
